import { render, staticRenderFns } from "./TopTenGrowers.vue?vue&type=template&id=abf798d6&"
import script from "./TopTenGrowers.vue?vue&type=script&lang=js&"
export * from "./TopTenGrowers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports